import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AfficheProductsService from "../../../Services/Admin/AfficheProductsService";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import Sidebare from "../Sidbare/Sidebare";
import axios from "axios";
import AfficheArticleInMagasin from "../../../Services/Magasin/AfficheArticleInMagasin";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import IMG from "./wired-outline-37-approve-checked-simple-hover-wobble.gif";
import { debounce } from "lodash";
import "./AllProduit.css";

export default function AllProduit() {
  const [search, setSearch]           = useState("");
  const [products, setProducts]       = useState<ArticleInfo[]>([]);
  const [alldata, setAlldata]         = useState<ArticleInfo[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 30;
  const [totalPages, setTotalPages]   = useState(1);
  const [loading, setLoading]         = useState(true);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [Refs, setRef]                = useState<any[]>([]);
  const [showPopup, setShowPopup]     = useState(false);
  const [Waiting, setWaiting]         = useState(false);
  const [Message, setMessage]         = useState("");
  const [mobileView, setMobileView]   = useState<"grid" | "list">("grid");

  const navigate = useNavigate();

  const isMobile = screenWidth <= 768;

  /* ── Search ───────────────────────────────────── */
  const debouncedGetRef = useMemo(
    () => debounce((value: string) => getRef(value), 300),
    []
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    localStorage.setItem("SaveTape", value);
    setSearch(value);
    debouncedGetRef(value);
  };

  const getRef = async (searchTerm: string, page: number = 1) => {
    try {
      if (searchTerm.trim() === "") {
        setRef([]); setTotalPages(1); setCurrentPage(1); return;
      }
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/search-articles`,
        { params: { q: searchTerm, page, perPage: recordsPerPage } }
      );
      setRef(response.data.data);
      setCurrentPage(response.data.current_page);
      setTotalPages(response.data.total_pages);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ── Restore last search ──────────────────────── */
  useEffect(() => {
    const saved = localStorage.getItem("SaveTape");
    if (!saved || saved.trim() === "") return;
    setSearch(saved);
    getRef(saved);
  }, []);

  /* ── Products fetch ───────────────────────────── */
  const fetchProducts = async () => {
    try {
      const res = await AfficheArticleInMagasin().getAnly20Article();
      setProducts(res.data.data);
      setAlldata(res.data.data);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchProducts();
      setLoading(false);
    };
    fetchData();
  }, []);

  /* ── Resize ───────────────────────────────────── */
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ── Update articles ──────────────────────────── */
  const UpdateArticles = async () => {
    try {
      setShowPopup(false);
      setWaiting(true);
      axios.get(`${process.env.REACT_APP_PHP_APP_URL}/articles`).catch(console.error);
      await new Promise((resolve) => setTimeout(resolve, 22000));
      setMessage("Vos produits ont été mis à jour avec succès");
      setTimeout(() => setMessage(""), 3500);
    } finally {
      setWaiting(false);
    }
  };

  /* ── Filtering ────────────────────────────────── */
  const filteredProducts = (Array.isArray(alldata) ? alldata : []).filter((pro: ArticleInfo) => {
    const refs = Array.isArray(pro.RefArticle) ? pro.RefArticle : [pro.RefArticle];
    return (
      search === "" ||
      pro.Designation?.toLowerCase().includes(search.toLowerCase()) ||
      pro.RefArticle?.toString().toLowerCase().includes(search.toLowerCase()) ||
      refs.some((r) => r?.toString().toLowerCase().includes(search.toLowerCase())) ||
      pro.DesignationAr?.toLowerCase().includes(search.toLowerCase()) ||
      pro.NomMarque?.toLowerCase().includes(search.toLowerCase())
    );
  });

  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const productsToRender = Refs && Refs.length > 0 ? Refs : paginatedProducts;

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      if (search.trim() !== "") {
        getRef(search, pageNumber);
      }
    }
  };

  /* ══════════════════════════════════════════════
     SUCCESS STATE
  ══════════════════════════════════════════════ */
  if (Message) {
    return (
      <>
        <NewSideBarAdmin />
        <div className="a-ad-up-status-screen">
          <div className="a-ad-up-status-card">
            <img src={IMG} alt="success" className="a-ad-up-status-gif" />
            <h2 className="a-ad-up-status-title">{Message}</h2>
            <div className="a-ad-up-status-bar" />
          </div>
        </div>
      </>
    );
  }

  /* ══════════════════════════════════════════════
     WAITING / UPDATE STATE
  ══════════════════════════════════════════════ */
  if (Waiting) {
    return (
      <>
        <NewSideBarAdmin />
        <div className="a-ad-up-status-screen">
          <div className="a-ad-up-status-card">
            <div className="a-ad-up-wait-spinner" />
            <h2 className="a-ad-up-wait-title">
              En attente du <span className="a-ad-up-wait-accent">Mise à jour</span>
            </h2>
            <p className="a-ad-up-wait-text">
              Synchronisation des produits en cours.<br />Veuillez patienter…
            </p>
            <div className="a-ad-up-wait-loader-row">
              <div className="a-ad-up-wait-mini-spin" />
              <span className="a-ad-up-wait-loader-label">CHARGEMENT EN COURS…</span>
            </div>
            <div className="a-ad-up-status-bar" />
            <p className="a-ad-up-wait-footer">Merci de votre patience</p>
          </div>
        </div>
      </>
    );
  }

  /* ══════════════════════════════════════════════
     MOBILE LAYOUT
  ══════════════════════════════════════════════ */
  if (isMobile) {
    return (
      <>
      <NewSideBarAdmin/>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css" />

        {/* ── Mobile sticky header ── */}
        <div className="a-mob-header">
          <div className="a-mob-header-top">
            <div className="a-mob-header-brand">
              <div className="a-mob-brand-dot" />
              <span className="a-mob-brand-label">Produits</span>
            </div>
            <div className="a-mob-header-actions">
              <button
                className="a-mob-icon-btn"
                onClick={() => setShowPopup(true)}
                title="Mettre à jour"
              >
                <i className="bi bi-arrow-repeat" />
              </button>
              <Link to="/articles/categories/add" className="a-mob-add-btn">
                <i className="bi bi-plus-lg" />
              </Link>
            </div>
          </div>

          {/* Search */}
          <div className="a-mob-search-wrap">
            <i className="bi bi-search a-mob-search-icon" />
            <input
              type="text"
              className="a-mob-search-input"
              onChange={handleSearch}
              value={search}
              placeholder="Rechercher un produit…"
            />
            {search && (
              <button
                className="a-mob-search-clear"
                onClick={() => { setSearch(""); setRef([]); localStorage.removeItem("SaveTape"); }}
              >
                <i className="bi bi-x" />
              </button>
            )}
          </div>

          {/* View toggle */}
          <div className="a-mob-view-toggle">
            <button
              className={`a-mob-toggle-btn ${mobileView === "grid" ? "a-mob-toggle-active" : ""}`}
              onClick={() => setMobileView("grid")}
            >
              <i className="bi bi-grid-3x3-gap" />
            </button>
            <button
              className={`a-mob-toggle-btn ${mobileView === "list" ? "a-mob-toggle-active" : ""}`}
              onClick={() => setMobileView("list")}
            >
              <i className="bi bi-list-ul" />
            </button>
          </div>
        </div>

        {/* ── Mobile body ── */}
        <div className="a-mob-body">

          {loading ? (
            <div className="a-mob-loader">
              <div className="a-mob-spinner" />
              <span className="a-mob-loader-text">Chargement…</span>
            </div>

          ) : productsToRender.length === 0 ? (
            <div className="a-mob-empty">
              <div className="a-mob-empty-icon"><i className="bi bi-emoji-neutral" /></div>
              <h5 className="a-mob-empty-title">Produit introuvable</h5>
              <p className="a-mob-empty-hint">Ce produit n'est pas disponible pour l'instant.</p>
              <Link to="https://api.whatsapp.com/send?phone=212661718081" target="_blank" className="a-mob-whatsapp-btn">
                <i className="bi bi-whatsapp" /> Contactez-nous
              </Link>
            </div>

          ) : mobileView === "grid" ? (
            /* ── Grid view ── */
<div className="a-mob-grid">
  {productsToRender && productsToRender.length > 0 &&
    productsToRender.map((pro: ArticleInfo, idx: number) => {
      const encodedRef = btoa(
        encodeURIComponent(pro?.RefArticle ?? "")
      );

      return (
        <Link
          key={pro?.IdArticle}
          className="a-mob-card-link"
          to={`/home/${encodeURIComponent(
            pro?.NomMagasin ?? ""
          )}/articles/${encodedRef}`}
          style={{ animationDelay: `${Math.min(idx, 8) * 0.05}s` }}
        >
          <div className="a-mob-card">
            <div className="a-mob-card-badge">
              {pro?.NomMagasin}
            </div>

            <div className="a-mob-card-img-wrap">
              <img
                src={pro?.urlImage}
                alt={pro?.Designation}
                className="a-mob-card-img"
              />

              <div className="a-mob-card-overlay">
                <span className="a-mob-card-price-pill">
                  {parseFloat(
                    String(pro?.PrixNetHT ?? 0).replace(",", ".")
                  ).toFixed(2)}
                  <small> MAD</small>
                </span>
              </div>
            </div>

            <div className="a-mob-card-body">
              <p className="a-mob-card-title">
                {pro?.Designation}
              </p>

              <p className="a-mob-card-ref">
                Réf · {pro?.RefArticle}
              </p>

              {pro?.LibelleFamArticle && (
                <p className="a-mob-card-fam">
                  <i className="bi bi-tag" /> {pro.LibelleFamArticle}
                </p>
              )}
            </div>
          </div>
        </Link>
      );
    })}
</div>

          ) : (
            /* ── List view ── */
<div className="a-mob-list">
  {productsToRender && productsToRender.length > 0 &&
    productsToRender.map((pro: ArticleInfo, idx: number) => {
      const encodedRef = btoa(
        encodeURIComponent(pro?.RefArticle ?? "")
      );

      return (
        <Link
          key={pro?.IdArticle}
          className="a-mob-list-link"
          to={`/home/${encodeURIComponent(
            pro?.NomMagasin ?? ""
          )}/articles/${encodedRef}`}
          style={{ animationDelay: `${Math.min(idx, 8) * 0.04}s` }}
        >
          <div className="a-mob-list-card">
            <div className="a-mob-list-img-wrap">
              <img
                src={pro?.urlImage}
                alt={pro?.Designation}
                className="a-mob-list-img"
              />
            </div>

            <div className="a-mob-list-info">
              <span className="a-mob-list-badge">
                {pro?.NomMagasin}
              </span>

              <p className="a-mob-list-title">
                {pro?.Designation}
              </p>

              <p className="a-mob-list-ref">
                Réf · {pro?.RefArticle}
              </p>

              {pro?.LibelleFamArticle && (
                <p className="a-mob-list-fam">
                  <i className="bi bi-tag" /> {pro.LibelleFamArticle}
                </p>
              )}
            </div>

            <div className="a-mob-list-right">
              <span className="a-mob-list-price">
                {parseFloat(
                  String(pro?.PrixNetHT ?? 0).replace(",", ".")
                ).toFixed(2)}
                <small>MAD</small>
              </span>

              <i className="bi bi-chevron-right a-mob-list-arrow" />
            </div>
          </div>
        </Link>
      );
    })}
</div>
          )}

          {/* Pagination */}
          {totalPages > 1 && !loading && (
            <div className="a-mob-pagination">
              <button
                className="a-mob-page-btn"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <i className="bi bi-chevron-left" />
              </button>
              <span className="a-mob-page-info">{currentPage} / {totalPages}</span>
              <button
                className="a-mob-page-btn"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <i className="bi bi-chevron-right" />
              </button>
            </div>
          )}
        </div>

        {/* Popup */}
        {showPopup && (
          <div className="a-ad-up-overlay">
            <div className="a-ad-up-popup">
              <div className="a-ad-up-popup-icon"><i className="bi bi-arrow-repeat" /></div>
              <h5 className="a-ad-up-popup-title">Mettre à jour les articles ?</h5>
              <p className="a-ad-up-popup-text">
                Cette action synchronise tous vos produits depuis la source. L'opération peut prendre quelques instants.
              </p>
              <div className="a-ad-up-popup-actions">
                <button className="a-ad-up-popup-btn-cancel" onClick={() => setShowPopup(false)}>Annuler</button>
                <button className="a-ad-up-popup-btn-confirm" onClick={UpdateArticles} disabled={loading}>
                  <i className="bi bi-check-lg" />
                  {loading ? "En cours…" : "Confirmer"}
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  /* ══════════════════════════════════════════════
     DESKTOP MAIN VIEW
  ══════════════════════════════════════════════ */
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"
      />
      <NewSideBarAdmin />

      <div className="a-ad-up-page">

        {/* ── Top bar ── */}
        <div className="a-ad-up-topbar">
          <div className="a-ad-up-topbar-left">
            <h3 className="a-ad-up-page-title">Tous les produits</h3>
          </div>
          <div className="a-ad-up-topbar-actions">
            <Link to="/articles/categories/add" className="a-ad-up-btn-add">
              <i className="bi bi-plus-lg" />
              Ajouter un produit
            </Link>
            <button
              className="a-ad-up-btn-refresh"
              onClick={() => setShowPopup(true)}
              aria-label="Mettre à jour"
              title="Mettre à jour les articles"
            >
              <i className="bi bi-arrow-repeat" />
            </button>
          </div>
        </div>

        {/* ── Search bar ── */}
        <div className="a-ad-up-search-wrap">
          <i className="bi bi-search a-ad-up-search-icon" />
          <input
            type="text"
            className="a-ad-up-search-input"
            onChange={handleSearch}
            value={search}
            placeholder="Rechercher un produit, référence, catégorie…"
          />
          {search && (
            <button
              className="a-ad-up-search-clear"
              onClick={() => { setSearch(""); setRef([]); localStorage.removeItem("SaveTape"); }}
            >
              <i className="bi bi-x" />
            </button>
          )}
          <i className="bi bi-sliders a-ad-up-search-filter-icon" />
        </div>

        {/* ── Products grid ── */}
{loading ? (
  <div className="a-ad-up-loader">
    <div className="a-ad-up-spinner" />
    <span className="a-ad-up-loader-text">Chargement…</span>
  </div>
) : productsToRender && productsToRender.length > 0 ? (
  <div className="a-ad-up-grid">
    {productsToRender.map((pro: ArticleInfo) => {
      const encodedRef = btoa(
        encodeURIComponent(pro?.RefArticle ?? "")
      );

      return (
        <Link
          key={pro?.IdArticle}
          className="a-ad-up-card-link"
          to={`/home/${encodeURIComponent(
            pro?.NomMagasin ?? ""
          )}/articles/${encodedRef}`}
        >
          <div className="a-ad-up-card">
            <div className="a-ad-up-card-badge">
              {pro?.NomMagasin}
            </div>

            <div className="a-ad-up-card-img-wrap">
              <img
                src={pro?.urlImage}
                alt={pro?.Designation}
                className="a-ad-up-card-img"
              />
              <div className="a-ad-up-card-actions">
                <button className="a-ad-up-action-btn">
                  <i className="bi bi-suit-heart" />
                </button>
                <button className="a-ad-up-action-btn a-ad-up-action-gold">
                  <i className="bi bi-cart" />
                </button>
              </div>
            </div>

            <div className="a-ad-up-card-body">
              <div className="a-ad-up-card-stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill a-ad-up-star" />
                ))}
              </div>

              <p className="a-ad-up-card-title">
                {pro?.Designation}
                {pro?.DesignationAr
                  ? ` · ${pro.DesignationAr}`
                  : ""}
              </p>

              <p className="a-ad-up-card-ref">
                Réf : {pro?.RefArticle}
              </p>

              {pro?.LibelleFamArticle && (
                <p className="a-ad-up-card-fam">
                  <i className="bi bi-tag" /> {pro.LibelleFamArticle}
                </p>
              )}

              <div className="a-ad-up-card-footer">
                <span className="a-ad-up-card-price">
                  {parseFloat(
                    String(pro?.PrixNetHT ?? 0).replace(",", ".")
                  ).toFixed(2)}
                  <small> MAD</small>
                </span>
              </div>
            </div>
          </div>
        </Link>
      );
    })}
  </div>
) : (
  <div className="a-ad-up-empty">
    <div className="a-ad-up-empty-icon">
      <i className="bi bi-emoji-neutral" />
    </div>
    <h5 className="a-ad-up-empty-title">
      Produit introuvable
    </h5>
    <p className="a-ad-up-empty-hint">
      Malheureusement, ce produit n'est pas disponible pour l'instant.
    </p>
    <Link
      to="https://api.whatsapp.com/send?phone=212661718081"
      target="_blank"
      className="a-ad-up-btn-whatsapp"
    >
      <i className="bi bi-whatsapp" /> Contactez-nous
    </Link>
  </div>
)}

        {/* ── Pagination ── */}
        {totalPages > 1 && !loading && (
          <div className="a-ad-up-pagination">
            <button
              className="a-ad-up-page-btn"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <i className="bi bi-chevron-left" />
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
              <button
                key={n}
                className={`a-ad-up-page-btn ${currentPage === n ? "a-ad-up-page-active" : ""}`}
                onClick={() => handlePageChange(n)}
              >
                {n}
              </button>
            ))}
            <button
              className="a-ad-up-page-btn"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        )}
      </div>

      {/* ── Confirm update popup ── */}
      {showPopup && (
        <div className="a-ad-up-overlay">
          <div className="a-ad-up-popup">
            <div className="a-ad-up-popup-icon">
              <i className="bi bi-arrow-repeat" />
            </div>
            <h5 className="a-ad-up-popup-title">Mettre à jour les articles ?</h5>
            <p className="a-ad-up-popup-text">
              Cette action synchronise tous vos produits depuis la source.
              L'opération peut prendre quelques instants.
            </p>
            <div className="a-ad-up-popup-actions">
              <button
                className="a-ad-up-popup-btn-cancel"
                onClick={() => setShowPopup(false)}
              >
                Annuler
              </button>
              <button
                className="a-ad-up-popup-btn-confirm"
                onClick={UpdateArticles}
                disabled={loading}
              >
                <i className="bi bi-check-lg" />
                {loading ? "En cours…" : "Confirmer"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}